<app-header></app-header>
<router-outlet></router-outlet>
<app-footer></app-footer>
<app-size-detector></app-size-detector>